// This file was automatically generated from app.shared.dialog.epcsApprove.html.
// Please don't edit this file by hand.

goog.provide('el8.template.app.shared.dialog.epcsApprove');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.shared.dialog.epcsApprove.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div><iframe src="', soy.$$escapeHtml(opt_data.url), '" width="100%" height="420px">Error during EPCS approve. Contact Elation Support.</iframe><div style="text-align: right; margin-right: 50px;"><a aria-label="How to update your EPCS token" class="el8FontBase el8LHBase" href="https://help.elationhealth.com/s/article/how-to-update-your-epcs-token" rel="noopener noreferrer" target="_blank">Trouble with token password or security code?</a></div></div>');
  if (!opt_sb) return output.toString();
};
